import { TScheduler } from '../Scheduler/types'
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormControl } from 'baseui/form-control';
import { TimezonePicker } from 'baseui/datepicker';
import { useStyletron } from 'baseui';
import { useIntl, } from 'react-intl';
import { ConfigurationPanel as SchedulerConfigurationPanel } from '../Scheduler/ConfigurationPanel'


export const ConfigurationPanel = (props: TScheduler) => {
    const [css, theme] = useStyletron();
    const intl = useIntl();
    const [timeZone, setTimeZone] = useSetObjectValue(props.id, props.resourceGroupId, "timeZone", props.timeZone);
    const handleTimeZoneChanged = (e: any) => setTimeZone(e.id);

    return (
        <>
            <SchedulerConfigurationPanel {...props}></SchedulerConfigurationPanel>

            <FormControl
                label={() => intl.formatMessage({ id: "Scheduler.Timezone", defaultMessage: "Timezone" })}
                caption={() => intl.formatMessage({ id: "Scheduler.TimezoneDescr", defaultMessage: "Select a Timezone for the scheduler to be used" })}>
                <TimezonePicker
                    value={timeZone}
                    onChange={handleTimeZoneChanged}

                />
            </FormControl>
        </>
    )
}
